import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';
import { DollarCircle } from 'iconsax-react';
import { TransactionType } from 'enum/transaction-type';
import { IStock } from 'types/custom/stock';

interface Props {
  stock: IStock | string;
  open: boolean;
  handleClose: (status: boolean) => void;
  handleConfirm: () => void;
  transactionType: TransactionType | null;
  stockPrice: number;
  quantity: number;
  users: number;
}

export default function AlertOrderConfirmation({
  stock,
  open,
  handleClose,
  handleConfirm,
  transactionType,
  stockPrice,
  quantity,
  users
}: Props) {
  const handleCancel = () => {
    handleClose(false);
  };
  const renderTransactionTypeSpecificContent = () => {
    switch (transactionType) {
      case TransactionType.BUY:
        return (
          <Typography align="center">
            You are about to place a <strong>{transactionType}</strong> order for <strong>{quantity}</strong> shares of{' '}
            <strong>{typeof stock === 'string' ? stock : stock?.stockName}</strong> at a price of{' '}
            <strong>
              &#x20B9;
              {stockPrice}
            </strong>{' '}
            per share for <strong>{users}</strong> {users === 1 ? 'user' : 'users'}.
          </Typography>
        );
      case TransactionType.SELL:
        return (
          <Typography align="center">
            You are about to place a <strong>{transactionType}</strong> order for <strong>{quantity}</strong> shares of{' '}
            <strong>{typeof stock === 'string' ? stock : stock?.stockName}</strong> at a price of{' '}
            <strong>
              &#x20B9;
              {stockPrice}
            </strong>{' '}
            per share for <strong>{users}</strong> {users === 1 ? 'user' : 'users'}.
          </Typography>
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="order-confirmation-title"
      aria-describedby="order-confirmation-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color={transactionType === TransactionType.BUY ? 'success' : 'error'} sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <DollarCircle variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              {transactionType === TransactionType.BUY ? 'Confirm Buy Order' : 'Confirm Sell Order'}
            </Typography>
            {renderTransactionTypeSpecificContent()}
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button fullWidth onClick={handleCancel} color="secondary" variant="outlined">
              Cancel
            </Button>
            <Button fullWidth color="primary" variant="contained" onClick={handleConfirm} autoFocus>
              Confirm
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
